import { render, staticRenderFns } from "./control-panel.vue?vue&type=template&id=2b2b9b06&scoped=true&"
import script from "./control-panel.vue?vue&type=script&lang=js&"
export * from "./control-panel.vue?vue&type=script&lang=js&"
import style0 from "./control-panel.vue?vue&type=style&index=0&id=2b2b9b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b9b06",
  null
  
)

export default component.exports